export enum DividerVariant {
  LIGHT = 'light',
  DARK = 'dark',
  PRIMARY = 'primary',
}

export enum DividerDirection {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}

export type DividerProps = {
  id?: string;
  testId?: string;
  title?: string;
  variant?: DividerVariant;
  direction?: DividerDirection;
  height?: number;
  width?: number;
  horizontalMargin?: number;
  verticalMargin?: number;
};
